import { Quote } from "lucide-react";

export default function MediaBreak() {
  return (
    <section data-testid="media-break" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="relative grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 relative">
            <div className="rounded-[28px] overflow-hidden aspect-[16/10] shadow-2xl ring-1 ring-slate-200 dark:ring-slate-800">
              <img
                src="https://images.pexels.com/photos/38034768/pexels-photo-38034768.jpeg"
                alt="Hundpromenad i parken"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="hidden md:flex absolute -bottom-10 -right-6 h-32 w-32 items-center justify-center rounded-3xl bg-emerald-500 text-white font-display font-bold text-2xl shadow-2xl rotate-3">
              <div className="text-center leading-tight">
                <div className="text-4xl">12k+</div>
                <div className="text-xs uppercase tracking-wider font-medium opacity-90">hundar</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-600 dark:text-emerald-400">
              Byggt i Sverige
            </div>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 dark:text-white">
              Hundälskare, för hundälskare.
            </h2>
            <p className="mt-5 text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
              Vi som bygger Hundify har själva drivit hundpensionat och dagis. Vi visste vad
              som saknades — så vi byggde det.
            </p>

            <blockquote className="mt-8 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 relative">
              <Quote className="absolute -top-3 -left-3 h-7 w-7 text-emerald-500" fill="currentColor" />
              <p className="text-slate-700 dark:text-slate-200 leading-relaxed">
                &ldquo;Vi sparar 18 timmar i månaden på admin. Hundifys digitala check-in har
                blivit en wow-faktor för våra kunder.&rdquo;
              </p>
              <footer className="mt-4 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 text-white font-display font-bold flex items-center justify-center">
                  M
                </div>
                <div>
                  <div className="font-semibold text-slate-900 dark:text-white text-sm">Maria Lindqvist</div>
                  <div className="text-xs text-slate-500 dark:text-slate-400">Ägare, Tassträff Hundpensionat</div>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
